import { Box, Container, Typography } from '@mui/material';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { usePrismicDocumentByUID } from '@prismicio/react';

import { utmQueryVar } from 'store/utils';
import { usePersistentSelectedCountry } from 'store/selectedCountry';
import Header from '@components/Header';
import ReviewCarousel from '@components/ReviewCarousel';
import { ReviewCarouselContent } from '@containers/HomePage/constant';
import FAQ from '@components/FAQ';
import Footer from '@components/Footer';
import { ICountryList } from '@utils/types';
import useAuth from '@utils/useAuth';
import { AppRoutes } from '@utils/appRoutes';

import CardBoxSection from './CardBoxSection';
import GiftWithUs from './GifiWithUs';
import FoodIsHappiness from './FoodIsHappiness';
// import { faqContent } from './constant';
import { useStyles } from './useStyles';
interface IGiftsPage {
  getServiceableCountries: ICountryList[];
}

const GiftsPage = ({ getServiceableCountries }: IGiftsPage) => {
  const classes = useStyles();

  const router = useRouter();
  const { detectedCountryCode } = useAuth();
  const selectedCountryDetail = usePersistentSelectedCountry(
    getServiceableCountries,
    detectedCountryCode
  );

  const [faqContent, { state, error }] = usePrismicDocumentByUID(
    'faq_component',
    'gifts-page-faq-12'
  );

  useEffect(() => {
    if (Object.keys(router?.query).length) {
      utmQueryVar(router?.query);
    }
  }, []);

  const onClickChat = () => {
    //@ts-ignore
    window?.fcWidget?.open();
  };

  const onClickGiftCard = () => {
    router.push({
      pathname: `${selectedCountryDetail?.country_code}${AppRoutes.GIFT_CARD_STEP_ONE}`,
      query: { isScrollToFaq: true },
    });
  };

  const onClickGiftBox = () => {
    // router.push({
    //   pathname: `https://www.thecuminclub.com/redirect?id=eyJpZCI6NywidHlwZSI6IkdJRlRCT1gifQ==`,
    //   query: { isScrollToFaq: true },
    // });

    router.push(
      `https://www.thecuminclub.com/redirect?id=eyJpZCI6NywidHlwZSI6IkdJRlRCT1gifQ==`
    );
  };

  return (
    <>
      <Box className={classes.heroSectionContainer}>
        <Header isBackground={false} TCCLogoFill="#F7C144" />
        <Box className={classes.titleWrapper}>
          <Typography
            variant="h1"
            align="center"
            color="whitePepper.main"
            className={classes.tilte}
          >
            Gift Shop
          </Typography>
        </Box>
      </Box>
      <CardBoxSection selectedCountryDetail={selectedCountryDetail} />
      <GiftWithUs />
      <ReviewCarousel
        carouselContent={ReviewCarouselContent}
        bgColor="turmeric.main"
        textColor="garamMasala.main"
      />
      <FoodIsHappiness selectedCountryDetail={selectedCountryDetail} />
      <Box bgcolor="whitePepper.main">
        <Container
          maxWidth="xl"
          disableGutters
          sx={{
            padding: '50px 25px 75px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <FAQ faqContent={faqContent} />
          {/* <Box>
            <Typography
              variant="body1"
              align="center"
              color="cumin.main"
              className={classes.faqReleated}
            >
              For FAQs related to the Gift Box and the Gift Card, please visit
              the{' '}
              <span className={classes.boldUnderline} onClick={onClickGiftBox}>
                Gift Box
              </span>{' '}
              and{' '}
              <span className={classes.boldUnderline} onClick={onClickGiftCard}>
                Gift Card
              </span>{' '}
              pages.
            </Typography>
          </Box> */}
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default GiftsPage;
